import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';
const serverUrlPath = publishObjectPath.serverUrl;

export class IntegralManagementServer {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 列表

  public getIntegralListData(opts: object) {
    const url = serverUrlPath + '/api/spaceManage/credit/staff';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 积分详情 人员信息
  public getIntegralInfoStaff(opts: object) {
    const url = serverUrlPath + '/api/spaceManage/credit/staff/details';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 积分详情 积分记录列表
  public getIntegralInfoRecord(opts: object) {
    const url = serverUrlPath + '/api/spaceManage/credit/record';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 操作积分
  public operationIntegral(opts: object) {
    const url = serverUrlPath + '/api/spaceManage/credit/record';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 全员清空
  public clearZeroIntegral(opts: object) {
    const url = serverUrlPath + '/api/spaceManage/credit/clearZero';
    return this.rSerivce.serverObj.post(url, opts);
  }
}
